import React, { useState, useContext, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import '../css/landing/explore.scss'
import { Typography, Button, Tabs, Tab, Box } from '@mui/material'
import ExplorePanel from '../component/landing/ExplorePanel'
import AboutUsPanel from '../component/landing/AboutUsPanel'
import ResearchersPanel from '../component/landing/ResearchersPanel'
import { AuthContext } from '../context/AuthContext' // Import AuthContext
import Loading from '../component/commonUnit/Loading' // Import Loading component
import SessionTable from '../component/session/SessionTable' // Import SessionTable component
import UserProfileSession from '../component/topBar/UserProfileSession' // Import UserProfileSession component
import {
  getSessionById,
  quitSession,
  quitSessionStudent,
} from '../service/sessionService' // Import quitSession and quitSessionStudent functions
import { SessionContext } from '../context/SessionContext' // Import SessionContext
import Session from './Session'

const About = () => {
  const navigate = useNavigate()
  const { currentUser } = useContext(AuthContext) // Use useContext to access AuthContext
  const { session, setSession, link } = useContext(SessionContext)

  const [selectedPanel, setSelectedPanel] = useState(0)
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'dark'
    const stored = window.localStorage.getItem('vzTheme') || 'dark'
    // Set synchronously during render (not in an effect) so the attribute is
    // already on <html> before first paint - avoids a dark-theme flash on mount.
    document.documentElement.setAttribute('data-vz-theme', stored)
    return stored
  })

  // Intentionally no cleanup: the attribute is harmless on other routes
  // (nothing outside .about-page reads --vz-* tokens), and removing it on
  // unmount only reintroduces the mount-flash this effect avoids.
  useEffect(() => {
    document.documentElement.setAttribute('data-vz-theme', theme)
    window.localStorage.setItem('vzTheme', theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'))
  }

  const handleLogin = () => {
    navigate('/login')
  }
  const handleSessionList = () => {
    navigate('/session')
  }

  const handleChange = (event, newValue) => {
    setSelectedPanel(newValue)
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const tabs = [
    { label: 'Explore' },
    { label: 'About Us' },
    { label: 'For Researchers' },
  ]

  return (
    <div className="about-page">
      <nav className="navbar">
        <div className="navbar-content">
          <div className="navbar-brand">
            <svg className="navbar-mark" viewBox="0 0 20 20" aria-hidden="true">
              <circle className="navbar-mark-pulse" cx="10" cy="4" r="2.4" />
              <circle cx="4" cy="15" r="2.4" opacity="0.55" />
              <circle cx="16" cy="15" r="2.4" opacity="0.55" />
            </svg>
            <Typography
              variant="h6"
              noWrap
              component="div"
              className="navbar-logo">
              VizPI
            </Typography>
          </div>

          <Tabs
            value={selectedPanel}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile>
            {tabs.map((tab, index) => (
              <Tab
                className="navbar-tab"
                label={tab.label}
                {...a11yProps(index)}
                key={index}
              />
            ))}
          </Tabs>

          <div className="navbar-login">
            <button
              type="button"
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
              {theme === 'dark' ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="4" />
                  <line x1="12" y1="2" x2="12" y2="4" />
                  <line x1="12" y1="20" x2="12" y2="22" />
                  <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
                  <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
                  <line x1="2" y1="12" x2="4" y2="12" />
                  <line x1="20" y1="12" x2="22" y2="12" />
                  <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
                  <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                </svg>
              )}
            </button>
            <Button
              className="login-button"
              onClick={currentUser ? handleSessionList : handleLogin}>
              {currentUser ? 'SESSION LIST' : 'Login'}
            </Button>
          </div>
        </div>
      </nav>

      {selectedPanel === 0 && <ExplorePanel />}
      {selectedPanel === 1 && <AboutUsPanel />}
      {selectedPanel === 2 && <ResearchersPanel />}
      <div className="site-footer"></div>
    </div>
  )
}

export default About
